// extracted by mini-css-extract-plugin
module.exports = {"i":"Icon_i__3TXKN"};